import React, { useMemo, Fragment, useState, useEffect } from "react"
import {
  Container,
  Col,
  Row,
  Button,
  Card,
  CardBody,
} from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useMutation } from "react-query"
import { useAsyncDebounce } from "react-table"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Swal from "sweetalert2"
import { GENERAL } from "api/general"

//i18n
import { withTranslation } from "react-i18next"
import PaginatedDataTable from "components/PaginatedDataTable"

const ViewRejectedAgentRegistrationsByLga = props => {
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [data, setRecords] = useState([])
  const [totalRecords, setTotalRecords] = useState(0)
  //meta title
  document.title = "Ward Registrars Management System"

  const [value, setValue] = React.useState("")
  const [filter, setFiilter] = React.useState("")
  const onChange = useAsyncDebounce(value => {
    setFiilter(value || undefined)
  }, 200)

  const handleSearchFn = async () => {
    Swal.fire({
      title: "Searching records...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(Swal.getDenyButton())
      },
    })
    await getRejectedList.mutateAsync({ page, pageSize, searchKey: filter ?? "" })
  }

  const fetchRecords = async () => {
    Swal.fire({
      title: "Fetching records...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(Swal.getDenyButton())
      },
    })

    try {
      await getRejectedList.mutateAsync({ page, pageSize, searchKey: filter ?? "" })
      Swal.close()
    } catch (error) {
      Swal.fire({
        title: "Error fetching records",
        text: error.message,
        icon: "error",
      })
    }
  }

  useEffect(() => {
    fetchRecords()
  }, [])

  const getRejectedList = useMutation({
    mutationFn: async ({ page, pageSize, searchKey }) => {
      return GENERAL.getRejectedLGARecordsList({ page, pageSize, searchKey })
    },
    onSuccess: async res => {
      Swal.close()
      setRecords(res.palliative)
      setTotalRecords(res.totalRecords)
      console.log(res)
    },
    onError: error => {
      Swal.fire("Error fetching records", error.message, "error")
    },
  })

  const columns = [
    {
      name: "#",
      sortable: true,
      selector: (row, index) => index + 1,
      width: "4rem",
    },
    {
      name: "Application ID",
      sortable: true,
      selector: row => row.npc_id,
    },
    {
      name: "First Name",
      sortable: true,
      selector: row => row.first_name,
    },
    {
      name: "Last Name",
      sortable: true,
      selector: row => row.last_name,
    },
    {
      name: "Date Created",
      sortable: true,
      selector: row => new Date(row.created_at).toLocaleDateString(),
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>
            <Breadcrumbs
              title={props.t("Rejected Ward Registrar Applications")}
              breadcrumbItem={props.t("Rejected Ward Registrar Applications By Lga")}
              hasBackBtn={true}
            />
          </Row>

          <Card>
            <CardBody>
              {/* <div className="mb-4 h4 card-title">Account Management</div> */}
              <Fragment>
                <Row className="mb-2">
                  <Col md={10}>
                    <React.Fragment>
                      <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
                        <div
                          className="position-relative"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <label
                            htmlFor="search-bar-0"
                            className="search-label"
                          >
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <input
                              onChange={e => {
                                setValue(e.target.value)
                                onChange(e.target.value)
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control"
                              placeholder={`Search table`}
                              value={value || ""}
                            />
                          </label>
                          <i
                            className="bx bx-search-alt search-icon"
                            style={{ cursor: "pointer" }}
                            onClick={handleSearchFn}
                          ></i>
                          <div
                            className="d-inline-block"
                            style={{ marginLeft: 5, marginBottom: 8 }}
                          >
                            <Button
                              type="button"
                              color="primary"
                              className="btn-md btn-rounded"
                              onClick={handleSearchFn}
                            >
                              Search
                            </Button>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  </Col>
                </Row>

                <PaginatedDataTable columns={columns} data={data} />
              </Fragment>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(ViewRejectedAgentRegistrationsByLga)
